import { requestAPI } from './requestApi';

export const getLeaderboard = (eventId: string) => requestAPI(`/events/${encodeURI(eventId)}/leaderboard/`);

export const getTaskLeaderboard = (eventId: string, taskId: string) => requestAPI(`/events/${encodeURI(eventId)}/leaderboard/tasks/${encodeURI(taskId)}`);

export const getLeaderboardWithSharedToken = (eventId: string, token: string) => requestAPI(`/events/${encodeURI(eventId)}/leaderboard?token=${encodeURIComponent(token)}`);
